import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';

export const cardSubheaderDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
    /** Returns title text */
    title: async () => base.$('[data-hook="title"]').text(),
    /** Returns title node */
    titleNode: async () => base.$('[data-hook="title-node"] > *'),
    /** Returns suffix node */
    suffixNode: async () => base.$(`[data-hook="suffix-node"] > *`),
  };
};
